import { Button, Drawer, Modal, Table, Tooltip, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { NotificationInfo, UserInfo } from "../../../context";
import { CheckCircleOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";

const MerchantInvoiceDetails = ({
  open,
  close,
  setLoading,
  getMerchantOrderSaveList,
  selectedData,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [confirmSpecDelivery, setConfirmSpecDelivery] = useState(false);
  const [detectWhenStatusOne, setDetectWhenStatusOne] = useState(false);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [total, setTotal] = useState(0);
  // const [totalZeroStatus, setTotalZeroStatus] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["proddeliveryproductinfo", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["proddeliveryproductinfo", "description"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Qty x Purchase SRP",
      // dataIndex: "quantity",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} x {text.proddeliveryproductinfo.purchase_srp}
        </>
      ),
    },
    {
      title: "Amount",
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.proddeliveryproductinfo.purchase_srp)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
    // {
    //   title: "",
    //   dataIndex: "",
    //   align: "center",
    //   render: (text) => (
    //     <p style={{ display: displayDetailsPrint ? "none" : "block" }}>
    //       <Tooltip title="Confirm">
    //         {/* {console.log("text", text)} */}
    //         <Button
    //           type="dashed"
    //           shape="circle"
    //           onClick={() => {
    //             setDialogData(text);
    //             setConfirmSpecDelivery(true);
    //           }}
    //           icon={<CheckCircleOutlined />}
    //           style={{ marginRight: 10 }}
    //           disabled={parseInt(text.status) === 1 ? true : false}
    //         />
    //       </Tooltip>
    //     </p>
    //   ),
    // },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].proddeliveryproductinfo.purchase_srp) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      dr_number: selectedData !== null ? selectedData.dr_number : "",
    };
    axios
      .get("user/merchant/spec-invoice-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("data", data);
        setOrderDetailsList({ data, ready: true });
        // setDetectWhenStatusOne(detectStatus(data));
        // setTotalZeroStatus(detectZeroStatus(data));
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  // const detectStatus = (data) => {
  //   var result = false;
  //   for (let i = 0; i < data.length; i++) {
  //     // console.log("data[i].status", data[i].status);
  //     if (parseInt(data[i].status) === 1) {
  //       result = true;
  //       // console.log("STATUS : TRUE");
  //     }
  //   }
  //   return result;
  // };

  // const detectZeroStatus = (data) => {
  //   var total = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     if (parseInt(data[i].status) === 0) {
  //       total += 1;
  //     }
  //   }
  //   return total;
  // };

  // const handleOk = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setOpenConfirmDiag(false);
  //     setConfirmLoading(false);
  //     handleConfirmDelivery();
  //   }, 2000);
  // };

  // const handleOKConfirmSpecDelivery = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setConfirmSpecDelivery(false);
  //     setConfirmLoading(false);
  //     handleConfirmSpecDelivery();
  //   }, 2000);
  // };

  // const handleConfirmDelivery = () => {
  //   const formdata = new FormData();
  //   formdata.append("user_id", userData.data.id);
  //   formdata.append(
  //     "invoice_number",
  //     selectedData !== null ? selectedData.invoice_number : ""
  //   );
  //   formdata.append(
  //     "po_number",
  //     selectedData !== null ? selectedData.po_number : ""
  //   );
  //   formdata.append(
  //     "po_number_id",
  //     selectedData !== null ? selectedData.po_number_id : ""
  //   );

  //   setLoadings(true);
  //   setLoading(true);
  //   axios
  //     .post("user/merchant/confirm-commissary-delivery", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data === "success") {
  //         rerunNotif("success", "Confirmed delivery successfully.");
  //         setTimeout(() => {
  //           // close();
  //           setLoadings(false);
  //           setLoading(false);
  //           // getMerchantOrderSaveList();
  //           getMerchantInvoiceDetails();
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoadings(false);
  //     });
  // };

  // const handleConfirmSpecDelivery = () => {
  //   const formdata = new FormData();
  //   formdata.append("user_id", userData.data.id);

  //   formdata.append(
  //     "invoice_number",
  //     selectedData !== null ? selectedData.invoice_number : ""
  //   );
  //   formdata.append(
  //     "po_number",
  //     selectedData !== null ? selectedData.po_number : ""
  //   );
  //   formdata.append(
  //     "po_number_id",
  //     selectedData !== null ? selectedData.po_number_id : ""
  //   );
  //   formdata.append("id", dialogData !== null ? dialogData.id : "");
  //   formdata.append("statuszerolength", parseInt(totalZeroStatus));

  //   setLoadings(true);
  //   setLoading(true);
  //   axios
  //     .post("user/merchant/confirm-spec-delivery", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data === "success") {
  //         rerunNotif("success", "Confirmed specific delivery successfully.");
  //         setTimeout(() => {
  //           if (parseInt(totalZeroStatus) === 1) {
  //             close();
  //           }
  //           setLoadings(false);
  //           setLoading(false);
  //           // getMerchantOrderSaveList();
  //           getMerchantInvoiceDetails();
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoadings(false);
  //     });
  // };

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Delivery Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          {/* <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button> */}
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
            // style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
          >
            Print
          </Button>
        </div>
      }
    >
      {/* {console.log("totalZeroStatus", totalZeroStatus)} */}
      {/* {console.log("selectedData", selectedData)} */}
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {displayDetailsPrint && (
              <Typography.Title style={{ marginBottom: 15 }}>
                Delivery Order
              </Typography.Title>
            )}
            <Typography
              style={{
                //  fontWeight: "bold",
                fontSize: 14,
              }}
            >
              Delivery Date:{" "}
              <span style={{ fontWeight: "bold" }}>
                {orderDetailsList.ready &&
                  moment(new Date(orderDetailsList.data[0].dr_date)).format(
                    "LLL"
                  )}
              </span>
            </Typography>

            <Typography
              style={{
                // fontWeight: "bold",
                fontSize: 14,
                textTransform: "capitalize",
                // marginBottom: 10,
              }}
            >
              P.O #:{" "}
              <span style={{ fontWeight: "bold" }}>
                {orderDetailsList.ready && orderDetailsList.data[0].po_number}
              </span>
            </Typography>
            <Typography
              style={{
                // fontWeight: "bold",
                fontSize: 14,
                textTransform: "capitalize",
                // marginBottom: 10,
              }}
            >
              Delivery #:{" "}
              <span style={{ fontWeight: "bold" }}>
                {orderDetailsList.ready && orderDetailsList.data[0].dr_number}
              </span>
            </Typography>
            <Typography
              style={{
                // fontWeight: "bold",
                fontSize: 14,
                textTransform: "capitalize",
                marginBottom: 10,
              }}
            >
              Delivery From:{" "}
              <span style={{ fontWeight: "bold" }}>
                {orderDetailsList.ready && orderDetailsList.data[0].dr_from}
              </span>
            </Typography>
          </div>

          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.id}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1, fontWeight: "bold" }}></div>
                Total:{" "}
                {total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
          />
        </div>
      )}

      {/* {console.log("selectedData", selectedData)} */}

      {/* need to be fixed */}
      {/* <Button
        type="primary"
        loading={loadings}
        // htmlType="submit"
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
        onClick={() => setOpenConfirmDiag(true)}
        disabled={detectWhenStatusOne ? true : false}
      >
        {loadings ? "Loading" : "Confirm all"}
      </Button> */}

      {/* <Button
        type="primary"
        onClick={handlePrint}
        icon={<PrinterOutlined />}
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
      >
        Print
      </Button> */}

      {/* <Modal
        title={
          <p style={{ marginTop: 30 }}>
            Are you sure to confirm all delivery and automatically added to your
            inventory?
          </p>
        }
        open={openConfirmDiag}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenConfirmDiag(false)}
      /> */}

      {/* <Modal
        title={
          <p style={{ marginTop: 30 }}>
            Are you sure to confirm this delivery and automatically added to
            your inventory?
          </p>
        }
        open={confirmSpecDelivery}
        onOk={handleOKConfirmSpecDelivery}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmSpecDelivery(false)}
      /> */}
    </Drawer>
  );
};

export default MerchantInvoiceDetails;
